export enum RecruiterPaymentlistTypes {
    FETCH_RECRUITER_PAYMENTLIST_SUCCESS = "FETCH_RECRUITER_PAYMENTLIST_SUCCESS",
    FETCH_RECRUITER_PAYMENTLIST_REQUEST = "FETCH_RECRUITER_PAYMENTLIST_REQUEST",
    FETCH_RECRUITER_PAYMENTLIST_FAILURE = "FETCH_RECRUITER_PAYMENTLIST_FAILURE",
}